import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { throwError } from 'rxjs';
import { DialogAction } from '../store/dialog.action';
import { ErrorsAction } from '../store/errors.state';

export class GenericService {

    constructor(private $store: Store) {
    }

    errorsAside = (rejection: HttpErrorResponse) => {
        if (rejection.status === 400) {
            this.$store.dispatch(new ErrorsAction.SaveAside(rejection.error));
        }
        return throwError(rejection);
    };

    errorsMain = (rejection: HttpErrorResponse) => {
        if (rejection.status === 400) {
            this.$store.dispatch(new ErrorsAction.SaveMain(rejection.error));
        }
        return throwError(rejection);
    };

    errorsDialog = (rejection: HttpErrorResponse) => {
        if (rejection.status === 400) {
            this.$store.dispatch(new ErrorsAction.SaveDialog(rejection.error));
        }
        return throwError(rejection);
    };

    cleanMain = () => {
        this.$store.dispatch(new ErrorsAction.CleanMain());
    };

    cleanAside = () => {
        this.$store.dispatch(new ErrorsAction.CleanAside());
    };

    cleanDialog = () => {
        this.$store.dispatch(new ErrorsAction.CleanDialog());
    };

    catchDialog = (response: HttpErrorResponse) => {
        this.$store.dispatch(new DialogAction.OpenDialogHttpError(response));
        return throwError(response);
    }
}
